module.exports = [
    {label:'微软雅黑',value:'微软雅黑'},
    {label:'黑体',value:'黑体'},
    {label:'宋体',value:'宋体'},
    {label:'仿宋',value:'仿宋'},
    {label:'楷体',value:'楷体'},
    {label:'华文宋体',value:'华文宋体'},
    {label:'庞门正道标题体',value:'pangMenTitle'},
    {label:'hooge',value:'hooge'},
    {label:'液晶数字体',value:'lccd'},
    {label:'840CAI978',value:'CAI978'},
    {label:'Arial',value:'Arial'},
    {label:'din-medium',value:'din-medium'},
    {label:'YouSheBiaoTiHei-2',value:'YouSheBiaoTiHei-2'},
    {label:'DINPro Medium',value:'DINPro Medium'},
    {label:'Helvetica-Neue',value:'Helvetica-Neue'},
    {label:'PingFangSCRegular',value:'PingFangSCRegular'},
    {label:'segoeui',value:'segoeui'},
    {label:'SourceHanSansCN-Normal',value:'SourceHanSansCN-Normal'},
    {label:'SourceHanSansCN-ExtraLight',value:'SourceHanSansCN-ExtraLight'},
    {label:'Helvetica-Neue-2',value:'Helvetica-Neue-2'},
]
